import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineUploadInProgress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M9.05 1.255a6.827 6.827 0 0 1 0 13.49M6.95 1.255a6.8 6.8 0 0 0-2.065.67M3.187 3.162a6.9 6.9 0 0 0-1.278 1.756m-.648 1.997a6.9 6.9 0 0 0 0 2.172m.648 1.997c.331.653.764 1.245 1.278 1.756m1.698 1.235a6.8 6.8 0 0 0 2.065.67" />
      <path d="M5.375 6.95 8 4.325l2.625 2.625M8 4.325v7.35" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineUploadInProgress;
